import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  mainHeadingTypographyStyles,
  rubikTypographyStyles,
} from '../../../shared/ui';

const GoalHeading = styled.div.attrs({
  'data-ui': 'registration-goals-goal-heading',
})`
  width: ${({ theme }) => theme.scale.px(341)};
  margin-left: ${({ theme }) => theme.scale.px(31)};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(8)};
`;

const Title = styled.h1`
  ${mainHeadingTypographyStyles};
  line-height: ${({ theme }) => theme.scale.px(28)};
`;

const Subtitle = styled.p`
  ${rubikTypographyStyles};
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 400;
  line-height: ${({ theme }) => theme.scale.px(18)};
`;

export function GoalIntroHeading() {
  const { t } = useTranslation();

  return (
    <GoalHeading>
      <Title>{t('registrationGoals.title')}</Title>
      <Subtitle>{t('registrationGoals.subtitle')}</Subtitle>
    </GoalHeading>
  );
}
